const statuses = {
  active: {
    name: 'active',
    icon: 'img/campaigns-cpc/ok.svg'
  },
  inactive: {
    name: 'inactive',
    icon: 'img/campaigns-cpc/ok2.svg'
  },
  canceled: {
    name: 'canceled',
    icon: 'img/campaigns-cpc/x.svg'
  }
}

export default statuses
